import { render, staticRenderFns } from "./ResetPwd.vue?vue&type=template&id=c8d8515c&scoped=true&"
import script from "./ResetPwd.vue?vue&type=script&lang=js&"
export * from "./ResetPwd.vue?vue&type=script&lang=js&"
import style0 from "./ResetPwd.vue?vue&type=style&index=0&id=c8d8515c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8d8515c",
  null
  
)

export default component.exports